import { useRef } from "react";
import { StageListComponent } from "../../components/StageComponents/StageListComponent";
import { Button, Tooltip } from "@etframework/ui.components";
import useModalEvent from "../../hooks/useModalEvent";
import { useTranslation } from "react-i18next";

export const Stage = () => {
  const { ModalEvents, toggleModal } = useModalEvent();
  const stagesListRef = useRef(null);
  const { t } = useTranslation(["Stages"]);

  return (
    <div className="d-flex flex-column et-stages m-2">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex">
          <span>{t("TaskStages")}</span>
          <Tooltip
            content={() => {
              return <span>{t("TaskStageTooltip")}</span>;
            }}
            openDelay={500}
            position="TopCenter"
            showTipPointer={false}
          >
            <i className={`fa-regular fa-circle-info icon`}></i>
          </Tooltip>
        </div>
        <Button
          id={"dd_settings_board-settings_add-stage-button"}
          text={t("CreateStage")}
          className="btn-tertiary w-auto add-btn"
          onClick={() => {
            toggleModal(ModalEvents.CreateStageModal);
          }}
          iconCss="fa-regular fa-plus"
        />
      </div>

      <div className="mt-3 stage-list">
        <StageListComponent
          id={"dd_settings_board-settings_stage-list"}
          ref={stagesListRef}
        />
      </div>
    </div>
  );
};
